import React, { useContext, useState, useEffect } from "react";
import { Box, TableRow, TableCell } from "@mui/material";

export const RowPopoutHandler = (props) => {
  return (
    <>
      {props.parentPayload?.type == "reviews" &&
        props.parentPayload.isExpanded == props.row.id && (
          <TableRow
            sx={{
              p: 0,
              backgroundColor: "#F5F5F5",
            }}
            key={props.row.id + "popout"}
          >
            <TableCell sx={{ p: 0 }} colSpan={props.cellsLength}>
              <Box sx={{ width: "100%" }}></Box>
            </TableCell>
          </TableRow>
        )}
    </>
  );
};
